// import {
//   Box,
//   FormControl,
//   FormLabel,
//   Icon,
//   SimpleGrid,
//   Text,
//   useColorModeValue,
//   useDisclosure,
//   Flex,
//   TagLabel,
//   Tag,
//   TagCloseButton,
//   Button
// } from '@chakra-ui/react';
// import ChatButton from './ChatButton';
// import Select from 'react-select';
// import InputField from 'components/fields/InputField';
// import { getCreator } from 'utils/creator/creator';
// import { getCompany } from 'utils/company/companyService';
// import React, { useEffect, useState, useRef } from 'react';
// import Card from 'components/card/Card';
// import Overviewdialognew from '../blocksCompo/Overviewdialognew';

// import AddCourse from './AddCourse';

// import {
//   getSkills,
//   getDefaultCat,
//   getDefaultSkill,
//   getGameStoryLine,
//    cognizantoverview,
//      cognizantoverviewgetmetho,
// } from 'utils/game/gameService';
// import { getCategoryList } from 'utils/category/category';

// import { AiOutlineEnter } from 'react-icons/ai';

// import {
//   onFocusField,
//   onFieldContentModified,
// } from '../../../../../store/preview/previewSlice';
// import { useDispatch } from 'react-redux';
// import { Dispatch } from '@reduxjs/toolkit';
// const AboutStory: React.FC<{
//   handleChange: (e: any) => void;
//   defaultskills: any;
//   setDefaultSkills: any;
//   formData: any;
//   setTags: any;
//   setFormData: any;
//   setCat: any;
//   id: any;
//   languages: any;
//   setChatNote: any;
//   chatNote: any;
// }> = ({
//   handleChange,
//   setDefaultSkills,
//   defaultskills,
//   formData,
//   setTags,
//   setFormData,
//   setCat,
//   id,
//   languages,
//   setChatNote,
//   chatNote,
// }) => {
//   const [openCourse, setOpenCourse] = useState(false),
//     [defaultCat, setDefaultCat] = useState([]),
//     [apiSkill, setApiSkill] = useState([]),
//     [apiCat, setApiCat] = useState([
//       {
//         name: 'War',
//         id: 1,
//       },
//     ]);

//   const dispatch: Dispatch<any> = useDispatch();
//   const [lastFocusedValue, setLastFocusedValue] = useState('');

//   const fetchCategoryList = async () => {
//     setDefaultCat([]);
//     const result = await getCategoryList();
//     if (result?.status !== 'Success')
//       return console.log('getbackruond error:' + result?.message);
//     setDefaultCat(result?.data);
//   };



//   const [showDialogue, setShowDialogue] = useState(false);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     const userId = user?.data?.id;
    
//     console.log("Login user id:", userId);
    
//     if (userId) {
//       // First get user details including company ID
//       getCreator(userId)
//         .then(userResult => {
//           console.log('Complete login user data:', userResult);
          
//           if (userResult?.data?.ctCompanyId) {
//             const companyId = userResult.data.ctCompanyId;
//             console.log('User company ID:', companyId);
            
//             // Now fetch company details using company ID
//             return getCompany(companyId)
//               .then(companyResult => {
//                 console.log('Company details:', companyResult);
                
//                 // Get company name - data is an array, so use [0]
//                 const companyName = companyResult?.data?.[0]?.cpCompanyName;
                
//                 console.log('User belongs to company:', companyName);
                
//                 // Now you can use companyName for your logic
//                 if (companyName?.toLowerCase() === 'cognizant') {
//                   setShowDialogue(true);
//                 } else {
//                   setShowDialogue(false);
//                 }
//               });
//           } else {
//             console.log('User has no company ID');
//             setShowDialogue(false);
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching user or company details:', error);
//           setShowDialogue(false);
//         });
//     }
//   }, []);
//   useEffect(() => {
//     setFormData((prev: any) => ({
//       ...prev,
//       gameSkills: defaultskills.length !== 0 ? defaultskills : '',
//     }));
//   }, [defaultskills]);

//   useEffect(() => {
//     fetchCategoryList();
//   }, []);

//   let borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');

//   let lightBlue = useColorModeValue('#3311db5c', '#3311db5c');

//   let textColor = useColorModeValue('black', 'white');

//   const keyPressSkill = (e: any) => {
//     if (e.keyCode === 13) {
//       const trimmedValue = e.target.value.trim(); // Remove leading and trailing whitespaces

//       if (trimmedValue !== '') {
//         setDefaultSkills([
//           ...defaultskills,
//           {
//             crSkillName: trimmedValue,
//             crSkillId:
//               defaultskills.length === 0
//                 ? 1
//                 : defaultskills[defaultskills.length - 1].crSkillId + 1,
//           },
//         ]);
//         /*** Start - To track the changes */
//         const newSkillValues = [
//           ...defaultskills,
//           {
//             crSkillName: trimmedValue,
//             crSkillId:
//               defaultskills.length === 0
//                 ? 1
//                 : defaultskills[defaultskills.length - 1].crSkillId + 1,
//           },
//         ];
//         foundValueChange(defaultskills, newSkillValues);

//         setFormData((prev: any) => ({
//           ...prev,
//           isSkillsInvalid: false, // Include the new property in the state
//         }));
//       }

//       e.target.value = '';
//     }
//   };

//   let previousLength = 0;

//   const handleInput = (event: any) => {
//     const bullet = '\u2022';
//     const currentValue = event.target.value;
//     const newLength = currentValue.length;
//     setValue(event.target.value);

//     if (event.nativeEvent instanceof InputEvent) {
//       const keyCode = (event.nativeEvent as InputEvent).inputType;

//       if (keyCode === 'insertLineBreak') {
//         // Handle Enter key or newline
//         event.preventDefault(); // Prevent the default behavior (line break)
//         event.target.value = `${currentValue}${bullet} `;
//       } else if (keyCode === 'deleteContentBackward') {
//         // Handle Backspace key
//         const lastBulletIndex = currentValue.lastIndexOf(bullet);
//         if (lastBulletIndex !== -1 && lastBulletIndex === newLength - 1) {
//           // If the last character is a space after a bullet, remove both
//           event.target.value = currentValue.slice(0, lastBulletIndex);
//         }
//       } else {
//         // Handle other key presses or additions
//         if (previousLength === 0 && currentValue.length <= 1) {
//           event.target.value = `${bullet} ${currentValue}`;
//         }
//         if (newLength > previousLength) {
//           if (currentValue.endsWith(bullet) || currentValue.trim() === bullet) {
//             // If the last character is a bullet or bullet with space, add a space after the bullet
//             event.preventDefault(); // Prevent the default behavior
//             event.target.value = `${currentValue} `;
//           }
//         }
//       }
//     }

//     setFormData((prev: any) => ({
//       ...prev,
//       gameLearningOutcome: event.target.value,
//     }));
//     previousLength = event.target.value.length;
//   };

//   const fetch = async () => {
//     const result = await getSkills();
//     if (result?.status !== 'Success')
//       return console.log('getSkills Error :', result?.error);
//     setApiSkill(result?.data);
//   };
//   useEffect(() => {
//     // fetch()
//   }, []);

//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const selectHandler = (selectedOption: any) => {
//     // Check if selectedOption is null (i.e., when clearing the selection)
//     const categoryId = selectedOption ? selectedOption.value : ''; // Assuming value is the property holding the category ID

//     setFormData((prev: any) => ({
//       ...prev,
//       gameCategoryId: categoryId,
//       isCategoryIdInvalid: false,
//     }));
//   };

//   const maxCharacters = 45;
//   const checkvalue = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     const trimmedValue1 = e.currentTarget.value.trim(); // Use currentTarget instead of target
//     if (trimmedValue1 !== '') {
//       setFormData((prev: any) => ({
//         ...prev,
//         isStoryTitleInvalid: false,
//       }));
//     }
//   };

//   const [height, setHeight] = useState(0);

//   const textareaRef = useRef<HTMLTextAreaElement | null>(null);
//   const textareaRefs = useRef<HTMLTextAreaElement | null>(null);
//   const textareaRefss = useRef<HTMLTextAreaElement | null>(null);

//   const [value, setValue] = useState<String>();

//   useEffect(() => {
//     if (textareaRef && textareaRef.current) {
//       textareaRef.current.style.height = '0px';
//       const scrollHeight = textareaRef.current.scrollHeight;
//       textareaRef.current.style.height = scrollHeight + 'px';
//     }
//   }, [formData?.gameStoryLine]);
//   useEffect(() => {
//     if (textareaRefss && textareaRefss.current) {
//       textareaRefss.current.style.height = '0px';
//       const scrollHeight = textareaRefss.current.scrollHeight;
//       textareaRefss.current.style.height = scrollHeight + 'px';
//     }
//   }, [value]);
//   useEffect(() => {
//     if (textareaRefs && textareaRefs.current) {
//       textareaRefs.current.style.height = '0px';
//       const scrollHeight = textareaRefs.current.scrollHeight;
//       textareaRefs.current.style.height = scrollHeight + 'px';
//     }
//   }, [value]);

//   const foundValueChange = async (original: any, updated: any) => {
//     if (original?.length !== updated?.length) {
//       triggerValueChange();
//     }
//   };
// //   const [overviewDialogs, setOverviewDialogs] = useState([
// //   { dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
// //   { dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
// //   { dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
// // ]);

//  const [overviewDialogs, setOverviewDialogs] = useState([
//       { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
//       { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
//       { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
//      { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
//      { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },

//     ]);

//   const triggerValueChange = async () => {
//     setTimeout(() => {
//       dispatch(
//         onFieldContentModified({
//           gameId: id,
//           modifiedField: null,
//           updatedValue: null,
//           isModified: true,
//         }),
//       );
//     }, 1250);
//   };

//   const handleOnBlurValue = (e: any) => {
//     const { name, value } = e.target;
//     if (lastFocusedValue.trim() !== value) {
//       dispatch(
//         onFieldContentModified({
//           gameId: formData.gameId,
//           modifiedField: name,
//           updatedValue: value,
//         }),
//       );
//     }
//   };
//   const gameidss =formData.gameId
//  useEffect(() => {
//   if (!gameidss) return;

//   const fetchOverview = async () => {
//     try {
//       const res = await cognizantoverviewgetmetho();

//       // ## grouped data by gameId
//       const gameData = res?.data?.[gameidss];

//       if (gameData && gameData.length > 0) {
//         // ## IMPORTANT: map backend → Overviewdialognew format
//         const mappedDialogs = gameData.map((item: any) => ({
//           dialog: item.text || "",

//           // ## character for react-select
//           character: {
//             value: item.characters,
//             label: item.characters,
//           },

//           // ## emotions JSON parse pannrom
//           emotion: item.emotions
//             ? JSON.parse(item.emotions).map((e: string) => ({
//                 value: e,
//                 label: e,
//               }))
//             : [],
//         }));

//         // ## set dialogs to new dialog UI
//         setOverviewDialogs(mappedDialogs);

//       } else {
//         // ## no data → empty 3 dialogs
//         setOverviewDialogs([
//           // { dialog: "", character: null, emotion: [] },
//           // { dialog: "", character: null, emotion: [] },
//           // { dialog: "", character: null, emotion: [] },
//            { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//                { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//                { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//         ]);
//       }

//     } catch (err) {
//       console.error("Fetch overview error", err);
//     }
//   };

//   fetchOverview();
// }, [gameidss]);

// //  const [overviewData, setOverViewData] = useState({
// //     dialog1: "",
// //     dialog2: "",
// //     dialog3: "",
// //     character: "Zane",            // ## DEFAULT CHARACTER
// //     blockChoosen: "hubdialogue",
// //     audio1: "/uploads/tta/Zane/Mentor1.mp3",   // dialog1 audio (optional)
// //   audio2: "/uploads/tta/Zane/Mentor2.mp3",   // dialog2 audio (optional)
// //   audio3: "/uploads/tta/Zane/Mentor3.mp3",   // dialog3 audio (optional)  // ## DEFAULT BLOCK
// //   });
//  const [overviewData, setOverViewData] = useState({
//       dialog1: "",
//       dialog2: "",
//       dialog3: "",
//       dialog4: "",
//       dialog5: "",
//       character: "Zane",            // ## DEFAULT CHARACTER
//       blockChoosen: "hubdialogue",
//       audio1: "/uploads/tta/Zane/Mentor1.mp3",   // dialog1 audio (optional)
//       audio2: "/uploads/tta/Zane/Mentor2.mp3",   // dialog2 audio (optional)
//       audio3: "/uploads/tta/Zane/Mentor3.mp3",   // dialog3 audio (optional)  // ## DEFAULT BLOCK
//        audio4: "/uploads/tta/Zane/Mentor4.mp3", 
//        audio5: "/uploads/tta/Zane/Mentor4.mp3", 
//     });
//     const handleChangeoverview = (e:any) => {
//     const { name, value } = e.target;

//     setOverViewData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleNextoverview = async () => {
//   try {
//     // ## STEP 2: Prepare payload dynamically from overviewDialogs
//     const payload = {
//        questNumber: overviewDialogs.map((d) => d.quest?.value ?? null),
//       gameId: gameidss,
//       characters: overviewDialogs.map((d) => d.character.label),
//       text: overviewDialogs.map((d) => d.dialog),
//       emotion: overviewDialogs.map((d) =>
//         d.emotion ? d.emotion.map((e: any) => e.label) : []
//       ),
//        audio: ['', '', ''],
//       blockChoosen: overviewData.blockChoosen,
//     };

//     console.log("Payload to backend:", payload);

//     const jsonPayload = JSON.stringify(payload);
//     const result = await cognizantoverview(jsonPayload);

//     if (result?.status === "Success") {
//       console.log("Saved ✅", result);
//       alert("Overview saved successfully");
//     } else {
//       alert("Save failed");
//     }
//   } catch (error) {
//     console.error("Server Error:", error);
//     alert("Server Error");
//   }
// };

//  useEffect(() => {
//       if (!gameidss) return;

//       const fetchOverview = async () => {
//         try {
//           const res = await cognizantoverviewgetmetho();

//           // ## grouped data by gameId
//           const gameData = res?.data?.[gameidss];

//           if (gameData && gameData.length > 0) {
//             // ## IMPORTANT: map backend → Overviewdialognew format
//             const mappedDialogs = gameData.map((item: any) => ({

//               // quest numbers
//               quest: item.questNumber
//                 ? { value: item.questNumber, label: `Quest ${item.questNumber}` }
//                 : { value: 1, label: 'Quest 1' }, // fallback
//               dialog: item.text || "",

//               // ## character for react-select
//               character: {
//                 value: item.characters,
//                 label: item.characters,
//               },

//               // ## emotions JSON parse pannrom
//               emotion: item.emotions
//                 ? JSON.parse(item.emotions).map((e: string) => ({
//                   value: e,
//                   label: e,
//                 }))
//                 : [],
//             }));

//             // ## set dialogs to new dialog UI
//             // setOverviewDialogs(mappedDialogs);
//             const REQUIRED = 4;
// const padded = [...mappedDialogs];

// while (padded.length < REQUIRED) {
//   padded.push({
//     quest: { value: 1, label: 'Quest 1' },
//     dialog: "",
//     character: { value: 999999, label: 'Player' },
//     emotion: [],
//   });
// }

// setOverviewDialogs(padded);


//           } else {
//             // ## no data → empty 3 dialogs
//             setOverviewDialogs([
//               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//                { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//                { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
//             ]);
//           }

//         } catch (err) {
//           console.error("Fetch overview error", err);
//         }
//       };

//       fetchOverview();
//     }, [gameidss]);
    
// //  useEffect(() => {
// //       if (!gameidss) return;

// //       const fetchOverview = async () => {
// //         try {
// //           const res = await cognizantoverviewgetmetho();

// //           // ## backend la grouped data
// //           const gameData = res?.data?.[gameidss];

// //           if (gameData && gameData.length > 0) {
// //             // ## data irundhaa textarea fill
// //             setOverViewData({
// //               dialog1: gameData[0]?.text || "",
// //               dialog2: gameData[1]?.text || "",
// //               dialog3: gameData[2]?.text || "",
// //               dialog4: gameData[3]?.text || "",
// //               character: gameData[0]?.characters || "Zane",
// //               blockChoosen: "hubdialogue",
// //               audio1: gameData[0]?.audio || "",
// //               audio2: gameData[1]?.audio || "",
// //               audio3: gameData[2]?.audio || "",
// //                audio4: gameData[3]?.audio || "",
// //             });
// //           } else {
// //             // ## data illa → empty textarea
// //             setOverViewData({
// //               dialog1: "",
// //               dialog2: "",
// //               dialog3: "",
// //               dialog4: "",
// //               character: "Zane",
// //               blockChoosen: "hubdialogue",
// //               audio1: "",
// //               audio2: "",
// //               audio3: "",
// //               audio4: "",
// //             });
// //           }

// //         } catch (err) {
// //           console.error("Fetch overview error", err);
// //         }
// //       };

// //       fetchOverview();

// //     }, [gameidss]);

// // useEffect(() => {
// //   if (!gameidss) return;

// //   const fetchOverview = async () => {
// //     try {
// //       const res = await cognizantoverviewgetmetho();

// //       // ## backend la grouped data
// //       const gameData = res?.data?.[gameidss];

// //       if (gameData && gameData.length > 0) {
// //         // ## data irundhaa textarea fill
// //         setOverViewData({
// //           dialog1: gameData[0]?.text || "",
// //           dialog2: gameData[1]?.text || "",
// //           dialog3: gameData[2]?.text || "",
// //           character: gameData[0]?.characters || "Zane",
// //           blockChoosen: "hubdialogue",
// //           audio1: gameData[0]?.audio || "",
// //           audio2: gameData[1]?.audio || "",
// //           audio3: gameData[2]?.audio || "",
// //         });
// //       } else {
// //         // ## data illa → empty textarea
// //         setOverViewData({
// //           dialog1: "",
// //           dialog2: "",
// //           dialog3: "",
// //           character: "Zane",
// //           blockChoosen: "hubdialogue",
// //           audio1: "",
// //           audio2: "",
// //           audio3: "",
// //         });
// //       }

// //     } catch (err) {
// //       console.error("Fetch overview error", err);
// //     }
// //   };

// //   fetchOverview();

// // }, [gameidss]);
//   return (
//     <>
//       <Card mb={{ base: '0px', xl: '20px', sm: '20px' }}>
//         <Flex
//           direction="column"
//           alignItems="center"
//           justifyContent="center"
//           textAlign="center"
//         >
//           <Card
//             w={{ sm: '100%', md: '65%' }}
//             boxShadow={{ base: '', md: '1px 4px 29px #44445429' }}
//             p={{ base: '0', md: '25px' }}
//           >
//             <Text
//               fontSize={20}
//               textAlign={'start'}
//               fontWeight={800}
//               mb={'20px'}
//               cursor={'pointer'}
//             >
//               Game Overview
//             </Text>

//             <SimpleGrid columns={{ base: 1, md: 1 }}>
//               <FormLabel
//                 fontWeight="bold"
//                 fontSize="sm"
//                 mb="8px"
//                 mt="10px"
//                 ml="10px"
//               >
//                 Title
//                 <Text as="span" color="red.500">
//                   *
//                 </Text>
//               </FormLabel>
//               <InputField
//                 id="title"
//                 mb="0px"
//                 width="100%"
//                 value={formData?.gameTitle}
//                 onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
//                   handleChange(e);
//                   // };
//                 }}
//                 onBlur={handleOnBlurValue}
//                 onFocus={(e: any) => setLastFocusedValue(e.target.value)}
//                 maxLength="45"
//                 placeholder="eg. Marketing Strategy"
//                 name="gameTitle"
//                 onKeyPress={checkvalue}
//                 style={{
//                   border: formData.isStoryTitleInvalid
//                     ? '1px solid red'
//                     : '1px solid #ccc',
//                 }}
//               />
//               <Text
//                 fontSize={'12px'}
//                 ml="2.5px"
//                 color={
//                   formData?.gameTitle?.length > maxCharacters ? 'red' : 'grey'
//                 }
//               >
//                 {maxCharacters - (formData?.gameTitle?.length || 0)} Characters
//                 left
//               </Text>
//             </SimpleGrid>
//             <SimpleGrid columns={{ base: 1, md: 1 }} mt={'10px'}>
//               <Box>
//                 <FormLabel
//                   fontWeight="bold"
//                   fontSize="sm"
//                   mb="8px"
//                   mt="10px"
//                   ml="10px"
//                 >
//                   Skills
//                   <Text as="span" color="red.500">
//                     *
//                   </Text>
//                 </FormLabel>
//                 <Flex
//                   direction="row"
//                   p="12px"
//                   wrap="wrap"
//                   bg="transparent"
//                   border="1px solid"
//                   borderColor={borderColor}
//                   borderRadius="16px"
//                   _focus={{ borderColor: 'teal.300' }}
//                   minH="30px"
//                   maxH="300px !important"
//                   h="stretch"
//                   cursor="text"
//                   style={{
//                     overflowY: 'auto',
//                     border: formData.isSkillsInvalid
//                       ? '1px solid red'
//                       : '1px solid #ccc',
//                   }}
//                 >
//                   {defaultskills &&
//                     defaultskills?.map((tag: any, index: any) => {
//                       return (
//                         <Tag
//                           fontSize="xs"
//                           h="25px"
//                           mb="6px"
//                           me="6px"
//                           borderRadius="12px"
//                           variant="solid"
//                           // bg={bg}
//                           bg={lightBlue}
//                           key={index}
//                         >
//                           <TagLabel w="100%" color={textColor}>
//                             {tag.crSkillName}
//                           </TagLabel>
//                           <TagCloseButton
//                             justifySelf="flex-end"
//                             color="black"
//                             onClick={() => {
//                               const updatedDefaultSkill = defaultskills.filter(
//                                 (element: any) =>
//                                   element.crSkillId !== tag.crSkillId,
//                               );
//                               setDefaultSkills(updatedDefaultSkill);
//                               triggerValueChange(); //Trigger value change when delete the Skill to update preview
//                             }}
//                           />
//                         </Tag>
//                       );
//                     })}
//                   <textarea
//                     ref={textareaRef}
//                     onKeyDown={(e: any) => keyPressSkill(e)}
//                     style={styles.textareaStyle}
//                     onFocus={(e: any) =>
//                       dispatch(
//                         onFocusField({ gameId: id, focusValue: defaultskills }),
//                       )
//                     }
//                   ></textarea>
//                 </Flex>
//                 <Text
//                   fontSize="xs"
//                   color="gray.500"
//                   mt="2px"
//                   style={{ textAlign: 'left' }}
//                 >
//                   <b>Note: </b> Press{' '}
//                   <Icon as={AiOutlineEnter} color="gray.500" /> To Add Skill
//                 </Text>
//               </Box>
//             </SimpleGrid>
//             <SimpleGrid columns={{ base: 1, md: 2, ml: 10 }} mt={'20px'}>
//               <Box>
//                 <FormLabel
//                   fontWeight="bold"
//                   fontSize="sm"
//                   mb="8px"
//                   mt="10px"
//                   ml="10px"
//                 >
//                   Storyline
//                 </FormLabel>
//                 <textarea
//                   ref={textareaRef}
//                   style={styles.textareaDefaultStyle}
//                   id="storyline"
//                   placeholder="eg. Embark on the 'Market Mastery Quest' where entrepreneur Alex navigates a virtual realm, mastering marketing strategy through dynamic challenges, rivalries, and ethical choices, aiming to emerge as the ultimate market master. Transforming learning into a thrilling adventure, this game blends strategy and innovation for real-world business success."
//                   name="gameStoryLine"
//                   value={formData?.gameStoryLine}
//                   onChange={handleChange}
//                   onBlur={handleOnBlurValue}
//                   onFocus={(e: any) =>
//                     setLastFocusedValue(String(e.target.value))
//                   }
//                 ></textarea>
//               </Box>
//             </SimpleGrid>
//             <SimpleGrid columns={{ base: 1, md: 2, ml: 10 }} mt={'20px'}>
//               <Box>
//                 <FormLabel
//                   fontWeight="bold"
//                   fontSize="sm"
//                   mb="8px"
//                   mt="10px"
//                   ml="10px"
//                 >
//                   Learning Outcomes
//                 </FormLabel>
//                 <textarea
//                   ref={textareaRefs}
//                   style={styles.textareaDefaultStyle}
//                   onChange={handleInput}
//                   // mb="10px"
//                   id="learningOutcome"
//                   placeholder="eg. Problem Solving"
//                   name="gameLearningOutcome"
//                   value={formData.gameLearningOutcome}
//                   onBlur={handleOnBlurValue}
//                   onFocus={(e: any) =>
//                     setLastFocusedValue(String(e.target.value))
//                   }
//                 ></textarea>
//               </Box>
//             </SimpleGrid>
//             <SimpleGrid columns={{ base: 1, md: 2, ml: 10 }} mt={'20px'}>
//               <Box>
//                 <FormControl>
//                   <FormLabel fontWeight="bold" fontSize="sm" mb="8px" ml="10px">
//                     Category
//                     <Text as="span" color="red.500">
//                       *
//                     </Text>
//                   </FormLabel>

//                   <Select
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                       control: (provided: any, state: any) => ({
//                         ...provided,
//                         borderRadius: '15px',
//                         height: '45px',
//                         padding: '0 !important',
//                         width: '100%',
//                         // window.innerWidth < 768 ? '100%' : '300px'
//                       }),
//                     }}
//                     options={defaultCat}
//                     onChange={(selectedOption) => selectHandler(selectedOption)}
//                     isClearable={true} // Optional: allow clearing the selection
//                     isSearchable={true} // Optional: enable searching
//                     className="react-select"
//                     value={
//                       defaultCat.find(
//                         (option) =>
//                           option?.value === parseInt(formData.gameCategoryId),
//                       ) || null
//                     }
//                   />
//                 </FormControl>
//               </Box>
//             </SimpleGrid>
//             <SimpleGrid columns={{ base: 1, md: 1 }} mt={'20px'}>
//               <FormLabel fontWeight="bold" fontSize="sm" mb="8px" ml="10px">
//                 Author<Text as="span"></Text>
//               </FormLabel>
//               <InputField
//                 mb="0px"
//                 // me="30px"
//                 id="author"
//                 // label="Author"
//                 placeholder="eg. Penelope Sterling"
//                 name="gameAuthorName"
//                 width="100%"
//                 value={formData?.gameAuthorName}
//                 onChange={handleChange}
//                 onBlur={handleOnBlurValue}
//                 onFocus={(e: any) =>
//                   setLastFocusedValue(String(e.target.value))
//                 }
//               />
//             </SimpleGrid>

             
         
//             <SimpleGrid columns={{ base: 1 }} mt="20px">
//   <FormLabel fontWeight="bold" fontSize="sm" mb="10px" ml="10px">
//     Overview Dialogs
//   </FormLabel>

// <Overviewdialognew
//   formData={formData}
//   overviewDialogs={overviewDialogs}          // ## pass state
//   setOverviewDialogs={setOverviewDialogs}    // ## pass setter
// />
// <button
//     onClick={handleNextoverview} // ## call updated handler
//     className="bg-blue-600 text-white px-4 py-2 rounded"
//   >
//     Next
//   </button>
// </SimpleGrid>

//           </Card>
//         </Flex>
//       </Card>
//       {openCourse ? (
//         <AddCourse
//           setOpenCourse={setOpenCourse}
//           isOpen={isOpen}
//           onClose={onClose}
//           onOpen={onOpen}
//         />
//       ) : null}
//       <ChatButton setChatNote={setChatNote} chatNote={chatNote} />
//     </>
//   );
// };
// export default AboutStory;

// const styles: { [name: string]: React.CSSProperties } = {
//   container: {
//     marginTop: 50,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   textareaDefaultStyle: {
//     padding: 5,
//     width: '100%',
//     display: 'block',
//     resize: 'none',
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     borderColor: '#E0E5F2', // Border color
//     outlineColor: '#E0E5F2', // Outline color
//     borderWidth: '1px', // Border width
//     borderStyle: 'solid', // Border style
//     overflow: 'auto', // Hide the scrollbar
//     fontSize: '0.875rem',
//     fontWeight: 500,
//     color: '#1b2559',
//   },
//   textareaStyle: {
//     padding: 2,
//     width: '100%',
//     // marginLeft:'10px',
//     display: 'block',
//     resize: 'none',
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     borderColor: 'white', // Border color
//     outlineColor: 'white', // Outline color
//     borderWidth: '1px', // Border width
//     borderStyle: 'solid', // Border style
//     overflow: 'hidden',
//   },
//   labelStyle: {
//     display: 'block',
//     fontSize: 'smaller',
//     fontWeight: 'bold',
//     marginBottom: '5px', // Add margin to separate label and textarea
//     marginRight: '430px',
//   },
//   labelLearningStyle: {
//     display: 'block',
//     fontSize: 'smaller',
//     fontWeight: 'bold',
//     marginBottom: '5px', // Add margin to separate label and textarea
//     marginRight: '370px',
//   },
// };


import {
  Box,
  FormControl,
  FormLabel,
  Icon,
  SimpleGrid,
  Text,
  useColorModeValue,
  useDisclosure,
  Flex,
  TagLabel,
  Tag,
  TagCloseButton,
  Button
} from '@chakra-ui/react';
import ChatButton from './ChatButton';
import Select from 'react-select';
import InputField from 'components/fields/InputField';
import { getCreator } from 'utils/creator/creator';
import { getCompany } from 'utils/company/companyService';
import React, { useEffect, useState, useRef } from 'react';
import Card from 'components/card/Card';
import Overviewdialognew from '../blocksCompo/Overviewdialognew';

import AddCourse from './AddCourse';

import {
  getSkills,
  getDefaultCat,
  getDefaultSkill,
  getGameStoryLine,
   cognizantoverview,
     cognizantoverviewgetmetho,
} from 'utils/game/gameService';
import { getCategoryList } from 'utils/category/category';

import { AiOutlineEnter } from 'react-icons/ai';

import {
  onFocusField,
  onFieldContentModified,
} from '../../../../../store/preview/previewSlice';
import { useDispatch } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';
const AboutStory: React.FC<{
  handleChange: (e: any) => void;
  defaultskills: any;
  setDefaultSkills: any;
  formData: any;
  setTags: any;
  setFormData: any;
  setCat: any;
  id: any;
  languages: any;
  setChatNote: any;
  chatNote: any;
}> = ({
  handleChange,
  setDefaultSkills,
  defaultskills,
  formData,
  setTags,
  setFormData,
  setCat,
  id,
  languages,
  setChatNote,
  chatNote,
}) => {
  const [openCourse, setOpenCourse] = useState(false),
    [defaultCat, setDefaultCat] = useState([]),
    [apiSkill, setApiSkill] = useState([]),
    [apiCat, setApiCat] = useState([
      {
        name: 'War',
        id: 1,
      },
    ]);

  const dispatch: Dispatch<any> = useDispatch();
  const [lastFocusedValue, setLastFocusedValue] = useState('');

  const fetchCategoryList = async () => {
    setDefaultCat([]);
    const result = await getCategoryList();
    if (result?.status !== 'Success')
      return console.log('getbackruond error:' + result?.message);
    setDefaultCat(result?.data);
  };



  const [showDialogue, setShowDialogue] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.data?.id;
    
    console.log("Login user id:", userId);
    
    if (userId) {
      // First get user details including company ID
      getCreator(userId)
        .then(userResult => {
          console.log('Complete login user data:', userResult);
          
          if (userResult?.data?.ctCompanyId) {
            const companyId = userResult.data.ctCompanyId;
            console.log('User company ID:', companyId);
            
            // Now fetch company details using company ID
            return getCompany(companyId)
              .then(companyResult => {
                console.log('Company details:', companyResult);
                
                // Get company name - data is an array, so use [0]
                const companyName = companyResult?.data?.[0]?.cpCompanyName;
                
                console.log('User belongs to company:', companyName);
                
                // Now you can use companyName for your logic
                if (companyName?.toLowerCase() === 'cognizant'|| 'CTS') {
                  setShowDialogue(true);
                } else {
                  setShowDialogue(false);
                }
              });
          } else {
            console.log('User has no company ID');
            setShowDialogue(false);
          }
        })
        .catch(error => {
          console.error('Error fetching user or company details:', error);
          setShowDialogue(false);
        });
    }
  }, []);
  useEffect(() => {
    setFormData((prev: any) => ({
      ...prev,
      gameSkills: defaultskills.length !== 0 ? defaultskills : '',
    }));
  }, [defaultskills]);

  useEffect(() => {
    fetchCategoryList();
  }, []);

  let borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');

  let lightBlue = useColorModeValue('#3311db5c', '#3311db5c');

  let textColor = useColorModeValue('black', 'white');

  const keyPressSkill = (e: any) => {
    if (e.keyCode === 13) {
      const trimmedValue = e.target.value.trim(); // Remove leading and trailing whitespaces

      if (trimmedValue !== '') {
        setDefaultSkills([
          ...defaultskills,
          {
            crSkillName: trimmedValue,
            crSkillId:
              defaultskills.length === 0
                ? 1
                : defaultskills[defaultskills.length - 1].crSkillId + 1,
          },
        ]);
        /*** Start - To track the changes */
        const newSkillValues = [
          ...defaultskills,
          {
            crSkillName: trimmedValue,
            crSkillId:
              defaultskills.length === 0
                ? 1
                : defaultskills[defaultskills.length - 1].crSkillId + 1,
          },
        ];
        foundValueChange(defaultskills, newSkillValues);

        setFormData((prev: any) => ({
          ...prev,
          isSkillsInvalid: false, // Include the new property in the state
        }));
      }

      e.target.value = '';
    }
  };

  let previousLength = 0;

  const handleInput = (event: any) => {
    const bullet = '\u2022';
    const currentValue = event.target.value;
    const newLength = currentValue.length;
    setValue(event.target.value);

    if (event.nativeEvent instanceof InputEvent) {
      const keyCode = (event.nativeEvent as InputEvent).inputType;

      if (keyCode === 'insertLineBreak') {
        // Handle Enter key or newline
        event.preventDefault(); // Prevent the default behavior (line break)
        event.target.value = `${currentValue}${bullet} `;
      } else if (keyCode === 'deleteContentBackward') {
        // Handle Backspace key
        const lastBulletIndex = currentValue.lastIndexOf(bullet);
        if (lastBulletIndex !== -1 && lastBulletIndex === newLength - 1) {
          // If the last character is a space after a bullet, remove both
          event.target.value = currentValue.slice(0, lastBulletIndex);
        }
      } else {
        // Handle other key presses or additions
        if (previousLength === 0 && currentValue.length <= 1) {
          event.target.value = `${bullet} ${currentValue}`;
        }
        if (newLength > previousLength) {
          if (currentValue.endsWith(bullet) || currentValue.trim() === bullet) {
            // If the last character is a bullet or bullet with space, add a space after the bullet
            event.preventDefault(); // Prevent the default behavior
            event.target.value = `${currentValue} `;
          }
        }
      }
    }

    setFormData((prev: any) => ({
      ...prev,
      gameLearningOutcome: event.target.value,
    }));
    previousLength = event.target.value.length;
  };

  const fetch = async () => {
    const result = await getSkills();
    if (result?.status !== 'Success')
      return console.log('getSkills Error :', result?.error);
    setApiSkill(result?.data);
  };
  useEffect(() => {
    // fetch()
  }, []);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const selectHandler = (selectedOption: any) => {
    // Check if selectedOption is null (i.e., when clearing the selection)
    const categoryId = selectedOption ? selectedOption.value : ''; // Assuming value is the property holding the category ID

    setFormData((prev: any) => ({
      ...prev,
      gameCategoryId: categoryId,
      isCategoryIdInvalid: false,
    }));
  };

  const maxCharacters = 45;
  const checkvalue = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const trimmedValue1 = e.currentTarget.value.trim(); // Use currentTarget instead of target
    if (trimmedValue1 !== '') {
      setFormData((prev: any) => ({
        ...prev,
        isStoryTitleInvalid: false,
      }));
    }
  };

  const [height, setHeight] = useState(0);

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const textareaRefs = useRef<HTMLTextAreaElement | null>(null);
  const textareaRefss = useRef<HTMLTextAreaElement | null>(null);

  const [value, setValue] = useState<String>();

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = '0px';
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + 'px';
    }
  }, [formData?.gameStoryLine]);
  useEffect(() => {
    if (textareaRefss && textareaRefss.current) {
      textareaRefss.current.style.height = '0px';
      const scrollHeight = textareaRefss.current.scrollHeight;
      textareaRefss.current.style.height = scrollHeight + 'px';
    }
  }, [value]);
  useEffect(() => {
    if (textareaRefs && textareaRefs.current) {
      textareaRefs.current.style.height = '0px';
      const scrollHeight = textareaRefs.current.scrollHeight;
      textareaRefs.current.style.height = scrollHeight + 'px';
    }
  }, [value]);

  const foundValueChange = async (original: any, updated: any) => {
    if (original?.length !== updated?.length) {
      triggerValueChange();
    }
  };
//   const [overviewDialogs, setOverviewDialogs] = useState([
//   { dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
//   { dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
//   { dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
// ]);

 const [overviewDialogs, setOverviewDialogs] = useState([
      { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
      { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
      { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
     { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },
     { quest: { value: 1, label: 'Quest 1' }, dialog: '', character: { value: 999999, label: 'Player' }, emotion: [] },

    ]);

  const triggerValueChange = async () => {
    setTimeout(() => {
      dispatch(
        onFieldContentModified({
          gameId: id,
          modifiedField: null,
          updatedValue: null,
          isModified: true,
        }),
      );
    }, 1250);
  };

  const handleOnBlurValue = (e: any) => {
    const { name, value } = e.target;
    if (lastFocusedValue.trim() !== value) {
      dispatch(
        onFieldContentModified({
          gameId: formData.gameId,
          modifiedField: name,
          updatedValue: value,
        }),
      );
    }
  };
  const gameidss =formData.gameId
 useEffect(() => {
  if (!gameidss) return;

  const fetchOverview = async () => {
    try {
      const res = await cognizantoverviewgetmetho();

      // ## grouped data by gameId
      const gameData = res?.data?.[gameidss];

      if (gameData && gameData.length > 0) {
        // ## IMPORTANT: map backend → Overviewdialognew format
        const mappedDialogs = gameData.map((item: any) => ({
              quest: item.questNumber
                ? { value: item.questNumber, label: `Quest ${item.questNumber}` }
                : { value: 1, label: 'Quest 1' }, // fallback
          dialog: item.text || "",

          // ## character for react-select
          character: {
            value: item.characters,
            label: item.characters,
          },

          // ## emotions JSON parse pannrom
          emotion: item.emotions
            ? JSON.parse(item.emotions).map((e: string) => ({
                value: e,
                label: e,
              }))
            : [],
        }));

            // ## set dialogs to new dialog UI
            const REQUIRED = 5;
            const padded = [...mappedDialogs];

            while (padded.length < REQUIRED) {
              padded.push({
                quest: { value: 1, label: 'Quest 1' },
                dialog: "",
                character: { value: 999999, label: 'Player' },
                emotion: [],
              });
            }

            setOverviewDialogs(padded);

      } else {
        // ## no data → empty 3 dialogs
        setOverviewDialogs([
          // { dialog: "", character: null, emotion: [] },
          // { dialog: "", character: null, emotion: [] },
          // { dialog: "", character: null, emotion: [] },
           { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
              { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
              { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
        ]);
      }

    } catch (err) {
      console.error("Fetch overview error", err);
    }
  };

  fetchOverview();
}, [gameidss]);

//  const [overviewData, setOverViewData] = useState({
//     dialog1: "",
//     dialog2: "",
//     dialog3: "",
//     character: "Zane",            // ## DEFAULT CHARACTER
//     blockChoosen: "hubdialogue",
//     audio1: "/uploads/tta/Zane/Mentor1.mp3",   // dialog1 audio (optional)
//   audio2: "/uploads/tta/Zane/Mentor2.mp3",   // dialog2 audio (optional)
//   audio3: "/uploads/tta/Zane/Mentor3.mp3",   // dialog3 audio (optional)  // ## DEFAULT BLOCK
//   });
 const [overviewData, setOverViewData] = useState({
      dialog1: "",
      dialog2: "",
      dialog3: "",
      dialog4: "",
      dialog5: "",
      character: "Zane",            // ## DEFAULT CHARACTER
      blockChoosen: "hubdialogue",
      audio1: "/uploads/tta/Zane/Mentor1.mp3",   // dialog1 audio (optional)
      audio2: "/uploads/tta/Zane/Mentor2.mp3",   // dialog2 audio (optional)
      audio3: "/uploads/tta/Zane/Mentor3.mp3",   // dialog3 audio (optional)  // ## DEFAULT BLOCK
       audio4: "/uploads/tta/Zane/Mentor4.mp3", 
       audio5: "/uploads/tta/Zane/Mentor4.mp3", 
    });
    const handleChangeoverview = (e:any) => {
    const { name, value } = e.target;

    setOverViewData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNextoverview = async () => {
  try {
    // ## STEP 2: Prepare payload dynamically from overviewDialogs
    const payload = {
       questNumber: overviewDialogs.map((d) => d.quest?.value ?? null),
      gameId: gameidss,
      characters: overviewDialogs.map((d) => d.character.label),
      text: overviewDialogs.map((d) => d.dialog),
      emotion: overviewDialogs.map((d) =>
        d.emotion ? d.emotion.map((e: any) => e.label) : []
      ),
       audio: ['', '', ''],
      blockChoosen: overviewData.blockChoosen,
    };

    console.log("Payload to backend:", payload);

    const jsonPayload = JSON.stringify(payload);
    const result = await cognizantoverview(jsonPayload);

    if (result?.status === "Success") {
      console.log("Saved ✅", result);
      alert("Overview saved successfully");
    } else {
      alert("Save failed");
    }
  } catch (error) {
    console.error("Server Error:", error);
    alert("Server Error");
  }
};

 useEffect(() => {
      if (!gameidss) return;

      const fetchOverview = async () => {
        try {
          const res = await cognizantoverviewgetmetho();

          // ## grouped data by gameId
          const gameData = res?.data?.[gameidss];

          if (gameData && gameData.length > 0) {
            // ## IMPORTANT: map backend → Overviewdialognew format
            const mappedDialogs = gameData.map((item: any) => ({

              // quest numbers
              quest: item.questNumber
                ? { value: item.questNumber, label: `Quest ${item.questNumber}` }
                : { value: 1, label: 'Quest 1' }, // fallback
              dialog: item.text || "",

              // ## character for react-select
              character: {
                value: item.characters,
                label: item.characters,
              },

              // ## emotions JSON parse pannrom
              emotion: item.emotions
                ? JSON.parse(item.emotions).map((e: string) => ({
                  value: e,
                  label: e,
                }))
                : [],
            }));

            // ## set dialogs to new dialog UI
            // setOverviewDialogs(mappedDialogs);
            const REQUIRED = 5;
            const padded = [...mappedDialogs];

while (padded.length < REQUIRED) {
  padded.push({
    quest: { value: 1, label: 'Quest 1' },
    dialog: "",
    character: { value: 999999, label: 'Player' },
    emotion: [],
  });
}

setOverviewDialogs(padded);


          } else {
            // ## no data → empty 3 dialogs
            setOverviewDialogs([
              { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
              { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
              { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
               { quest: { value: 1, label: 'Quest 1' }, dialog: "", character: null, emotion: [] },
            ]);
          }

        } catch (err) {
          console.error("Fetch overview error", err);
        }
      };

      fetchOverview();
    }, [gameidss]);
    
//  useEffect(() => {
//       if (!gameidss) return;

//       const fetchOverview = async () => {
//         try {
//           const res = await cognizantoverviewgetmetho();

//           // ## backend la grouped data
//           const gameData = res?.data?.[gameidss];

//           if (gameData && gameData.length > 0) {
//             // ## data irundhaa textarea fill
//             setOverViewData({
//               dialog1: gameData[0]?.text || "",
//               dialog2: gameData[1]?.text || "",
//               dialog3: gameData[2]?.text || "",
//               dialog4: gameData[3]?.text || "",
//               character: gameData[0]?.characters || "Zane",
//               blockChoosen: "hubdialogue",
//               audio1: gameData[0]?.audio || "",
//               audio2: gameData[1]?.audio || "",
//               audio3: gameData[2]?.audio || "",
//                audio4: gameData[3]?.audio || "",
//             });
//           } else {
//             // ## data illa → empty textarea
//             setOverViewData({
//               dialog1: "",
//               dialog2: "",
//               dialog3: "",
//               dialog4: "",
//               character: "Zane",
//               blockChoosen: "hubdialogue",
//               audio1: "",
//               audio2: "",
//               audio3: "",
//               audio4: "",
//             });
//           }

//         } catch (err) {
//           console.error("Fetch overview error", err);
//         }
//       };

//       fetchOverview();

//     }, [gameidss]);

// useEffect(() => {
//   if (!gameidss) return;

//   const fetchOverview = async () => {
//     try {
//       const res = await cognizantoverviewgetmetho();

//       // ## backend la grouped data
//       const gameData = res?.data?.[gameidss];

//       if (gameData && gameData.length > 0) {
//         // ## data irundhaa textarea fill
//         setOverViewData({
//           dialog1: gameData[0]?.text || "",
//           dialog2: gameData[1]?.text || "",
//           dialog3: gameData[2]?.text || "",
//           character: gameData[0]?.characters || "Zane",
//           blockChoosen: "hubdialogue",
//           audio1: gameData[0]?.audio || "",
//           audio2: gameData[1]?.audio || "",
//           audio3: gameData[2]?.audio || "",
//         });
//       } else {
//         // ## data illa → empty textarea
//         setOverViewData({
//           dialog1: "",
//           dialog2: "",
//           dialog3: "",
//           character: "Zane",
//           blockChoosen: "hubdialogue",
//           audio1: "",
//           audio2: "",
//           audio3: "",
//         });
//       }

//     } catch (err) {
//       console.error("Fetch overview error", err);
//     }
//   };

//   fetchOverview();

// }, [gameidss]);
  return (
    <>
      <Card mb={{ base: '0px', xl: '20px', sm: '20px' }}>
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <Card
            w={{ sm: '100%', md: '65%' }}
            boxShadow={{ base: '', md: '1px 4px 29px #44445429' }}
            p={{ base: '0', md: '25px' }}
          >
            <Text
              fontSize={20}
              textAlign={'start'}
              fontWeight={800}
              mb={'20px'}
              cursor={'pointer'}
            >
              Game Overview
            </Text>

            <SimpleGrid columns={{ base: 1, md: 1 }}>
              <FormLabel
                fontWeight="bold"
                fontSize="sm"
                mb="8px"
                mt="10px"
                ml="10px"
              >
                Title
                <Text as="span" color="red.500">
                  *
                </Text>
              </FormLabel>
              <InputField
                id="title"
                mb="0px"
                width="100%"
                value={formData?.gameTitle}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  handleChange(e);
                  // };
                }}
                onBlur={handleOnBlurValue}
                onFocus={(e: any) => setLastFocusedValue(e.target.value)}
                maxLength="45"
                placeholder="eg. Marketing Strategy"
                name="gameTitle"
                onKeyPress={checkvalue}
                style={{
                  border: formData.isStoryTitleInvalid
                    ? '1px solid red'
                    : '1px solid #ccc',
                }}
              />
              <Text
                fontSize={'12px'}
                ml="2.5px"
                color={
                  formData?.gameTitle?.length > maxCharacters ? 'red' : 'grey'
                }
              >
                {maxCharacters - (formData?.gameTitle?.length || 0)} Characters
                left
              </Text>
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, md: 1 }} mt={'10px'}>
              <Box>
                <FormLabel
                  fontWeight="bold"
                  fontSize="sm"
                  mb="8px"
                  mt="10px"
                  ml="10px"
                >
                  Skills
                  <Text as="span" color="red.500">
                    *
                  </Text>
                </FormLabel>
                <Flex
                  direction="row"
                  p="12px"
                  wrap="wrap"
                  bg="transparent"
                  border="1px solid"
                  borderColor={borderColor}
                  borderRadius="16px"
                  _focus={{ borderColor: 'teal.300' }}
                  minH="30px"
                  maxH="300px !important"
                  h="stretch"
                  cursor="text"
                  style={{
                    overflowY: 'auto',
                    border: formData.isSkillsInvalid
                      ? '1px solid red'
                      : '1px solid #ccc',
                  }}
                >
                  {defaultskills &&
                    defaultskills?.map((tag: any, index: any) => {
                      return (
                        <Tag
                          fontSize="xs"
                          h="25px"
                          mb="6px"
                          me="6px"
                          borderRadius="12px"
                          variant="solid"
                          // bg={bg}
                          bg={lightBlue}
                          key={index}
                        >
                          <TagLabel w="100%" color={textColor}>
                            {tag.crSkillName}
                          </TagLabel>
                          <TagCloseButton
                            justifySelf="flex-end"
                            color="black"
                            onClick={() => {
                              const updatedDefaultSkill = defaultskills.filter(
                                (element: any) =>
                                  element.crSkillId !== tag.crSkillId,
                              );
                              setDefaultSkills(updatedDefaultSkill);
                              triggerValueChange(); //Trigger value change when delete the Skill to update preview
                            }}
                          />
                        </Tag>
                      );
                    })}
                  <textarea
                    ref={textareaRef}
                    onKeyDown={(e: any) => keyPressSkill(e)}
                    style={styles.textareaStyle}
                    onFocus={(e: any) =>
                      dispatch(
                        onFocusField({ gameId: id, focusValue: defaultskills }),
                      )
                    }
                  ></textarea>
                </Flex>
                <Text
                  fontSize="xs"
                  color="gray.500"
                  mt="2px"
                  style={{ textAlign: 'left' }}
                >
                  <b>Note: </b> Press{' '}
                  <Icon as={AiOutlineEnter} color="gray.500" /> To Add Skill
                </Text>
              </Box>
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, md: 2, ml: 10 }} mt={'20px'}>
              <Box>
                <FormLabel
                  fontWeight="bold"
                  fontSize="sm"
                  mb="8px"
                  mt="10px"
                  ml="10px"
                >
                  Storyline
                </FormLabel>
                <textarea
                  ref={textareaRef}
                  style={styles.textareaDefaultStyle}
                  id="storyline"
                  placeholder="eg. Embark on the 'Market Mastery Quest' where entrepreneur Alex navigates a virtual realm, mastering marketing strategy through dynamic challenges, rivalries, and ethical choices, aiming to emerge as the ultimate market master. Transforming learning into a thrilling adventure, this game blends strategy and innovation for real-world business success."
                  name="gameStoryLine"
                  value={formData?.gameStoryLine}
                  onChange={handleChange}
                  onBlur={handleOnBlurValue}
                  onFocus={(e: any) =>
                    setLastFocusedValue(String(e.target.value))
                  }
                ></textarea>
              </Box>
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, md: 2, ml: 10 }} mt={'20px'}>
              <Box>
                <FormLabel
                  fontWeight="bold"
                  fontSize="sm"
                  mb="8px"
                  mt="10px"
                  ml="10px"
                >
                  Learning Outcomes
                </FormLabel>
                <textarea
                  ref={textareaRefs}
                  style={styles.textareaDefaultStyle}
                  onChange={handleInput}
                  // mb="10px"
                  id="learningOutcome"
                  placeholder="eg. Problem Solving"
                  name="gameLearningOutcome"
                  value={formData.gameLearningOutcome}
                  onBlur={handleOnBlurValue}
                  onFocus={(e: any) =>
                    setLastFocusedValue(String(e.target.value))
                  }
                ></textarea>
              </Box>
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, md: 2, ml: 10 }} mt={'20px'}>
              <Box>
                <FormControl>
                  <FormLabel fontWeight="bold" fontSize="sm" mb="8px" ml="10px">
                    Category
                    <Text as="span" color="red.500">
                      *
                    </Text>
                  </FormLabel>

                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (provided: any, state: any) => ({
                        ...provided,
                        borderRadius: '15px',
                        height: '45px',
                        padding: '0 !important',
                        width: '100%',
                        // window.innerWidth < 768 ? '100%' : '300px'
                      }),
                    }}
                    options={defaultCat}
                    onChange={(selectedOption) => selectHandler(selectedOption)}
                    isClearable={true} // Optional: allow clearing the selection
                    isSearchable={true} // Optional: enable searching
                    className="react-select"
                    value={
                      defaultCat.find(
                        (option) =>
                          option?.value === parseInt(formData.gameCategoryId),
                      ) || null
                    }
                  />
                </FormControl>
              </Box>
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, md: 1 }} mt={'20px'}>
              <FormLabel fontWeight="bold" fontSize="sm" mb="8px" ml="10px">
                Author<Text as="span"></Text>
              </FormLabel>
              <InputField
                mb="0px"
                // me="30px"
                id="author"
                // label="Author"
                placeholder="eg. Penelope Sterling"
                name="gameAuthorName"
                width="100%"
                value={formData?.gameAuthorName}
                onChange={handleChange}
                onBlur={handleOnBlurValue}
                onFocus={(e: any) =>
                  setLastFocusedValue(String(e.target.value))
                }
              />
            </SimpleGrid>

             
         
            <SimpleGrid columns={{ base: 1 }} mt="20px">
  <FormLabel fontWeight="bold" fontSize="sm" mb="10px" ml="10px">
    Overview Dialogs
  </FormLabel>

                <Overviewdialognew
                  formData={formData}
                  overviewDialogs={overviewDialogs}          // ## pass state
                  setOverviewDialogs={setOverviewDialogs}    // ## pass setter
                />
                {/* <div className="flex gap-2 mt-4"> */}
                  <button
                    onClick={() => {
                      const newDialog = {
                        quest: { value: 1, label: 'Quest 1' },
                        character: { value: 999999, label: 'Player' },
                        dialog: '',
                        emotion: [] as any[]
                      };
                      setOverviewDialogs([...overviewDialogs, newDialog]);
                    }}
                    className="bg-green-600 text-white px-4 py-2 rounded"
                  >
                    Add Dialog
                  </button>
                  {/* </div> */}
                  <br />
                  <button
                    onClick={handleNextoverview} // ## call updated handler
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                  >
                    Next
                  </button>
                
              </SimpleGrid>

          </Card>
        </Flex>
      </Card>
      {openCourse ? (
        <AddCourse
          setOpenCourse={setOpenCourse}
          isOpen={isOpen}
          onClose={onClose}
          onOpen={onOpen}
        />
      ) : null}
      <ChatButton setChatNote={setChatNote} chatNote={chatNote} />
    </>
  );
};
export default AboutStory;

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    marginTop: 50,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textareaDefaultStyle: {
    padding: 5,
    width: '100%',
    display: 'block',
    resize: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    borderColor: '#E0E5F2', // Border color
    outlineColor: '#E0E5F2', // Outline color
    borderWidth: '1px', // Border width
    borderStyle: 'solid', // Border style
    overflow: 'auto', // Hide the scrollbar
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#1b2559',
  },
  textareaStyle: {
    padding: 2,
    width: '100%',
    // marginLeft:'10px',
    display: 'block',
    resize: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    borderColor: 'white', // Border color
    outlineColor: 'white', // Outline color
    borderWidth: '1px', // Border width
    borderStyle: 'solid', // Border style
    overflow: 'hidden',
  },
  labelStyle: {
    display: 'block',
    fontSize: 'smaller',
    fontWeight: 'bold',
    marginBottom: '5px', // Add margin to separate label and textarea
    marginRight: '430px',
  },
  labelLearningStyle: {
    display: 'block',
    fontSize: 'smaller',
    fontWeight: 'bold',
    marginBottom: '5px', // Add margin to separate label and textarea
    marginRight: '370px',
  },
};
